import {stringCompare} from '@lib/utils';
import {ConnectionUser} from '../entities';

export const sortConnectionUsers = (u1: ConnectionUser, u2: ConnectionUser) => {
  if (u1.name && u2.name) {
    return stringCompare(u1.name, u2.name);
  }
  if (u1.name) {
    return -1;
  }
  if (u2.name) {
    return 1;
  }

  // If both don't have names, use email
  return stringCompare(u1.email, u2.email);
};
